import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useTheme } from '@mui/material/styles';

import { useGetProgramSets } from '../../../redux/api/programsAPI';
import { IProgramSet } from '../../../types/interfaces/program-set';
import { orderBy } from '../../../utils/collections/array-utils';
import { AppBarWithButtons } from '../../designe/app-bars/app-bar-with-action-buttons/AppBarWithButtons';
import AppSelectWrapper from '../../designe/textfields/app-select-wrapper/AppSelectWrapper';
import { useStyles } from './SavedProgramSet.style';

interface ISavedProgramSetProps {
  onCancel: () => void;
  onSubmitSavedProgramSet: (v: IProgramSet) => void;
}

export default function SavedProgramSet(props: ISavedProgramSetProps) {
  const { onCancel, onSubmitSavedProgramSet } = props;
  const [selectedSet, setSelectedSet] = useState(null);
  const { data: programSets } = useGetProgramSets();
  const { t } = useTranslation();
  const theme = useTheme();
  const { classes } = useStyles(theme);

  const sortedProgramSets = orderBy(programSets, 'title');

  return (
    <div className={classes.savedProgramSetWrapper}>
      <div>
        <AppSelectWrapper
          label={t('programs.savedProgramSet')}
          fieldName={'title'}
          options={sortedProgramSets}
          defaultValue={selectedSet}
          onChange={(e) => {
            setSelectedSet(e?.target?.value || null);
          }}></AppSelectWrapper>
      </div>

      <div className={classes.savedProgramSetBottom}>
        <AppBarWithButtons
          disabled={!selectedSet}
          onClick={() => {
            onSubmitSavedProgramSet(selectedSet);
          }}
          onCancelClick={onCancel}
        />
      </div>
    </div>
  );
}
